import { type TIntegrationCategory, CATEGORIES } from '../models/Unified';
import { RETIRED_CATEGORY_SLUGS } from './redirects';

export const MAP_CATS: Record<Exclude<TIntegrationCategory, 'passthrough' | 'metadata'>, string> = CATEGORIES.reduce(
    (acc, cat) => {
        acc[cat.category as Exclude<TIntegrationCategory, 'passthrough' | 'metadata'>] = cat.label;
        return acc;
    },
    {} as Record<Exclude<TIntegrationCategory, 'passthrough' | 'metadata'>, string>
);

/** MAP_CATS slugs that have a `/[category]` page. `passthrough` and `metadata` stay in MAP_CATS for
 * integration labels, but pages/[category].vue 404s on them, so they must not be linked or prerendered. */
export const CATEGORY_PAGE_SLUGS = (Object.keys(MAP_CATS) as (keyof typeof MAP_CATS)[]).filter(
    (c) => (c as string) !== 'passthrough' && (c as string) !== 'metadata' && !RETIRED_CATEGORY_SLUGS.includes(c as string)
);

/** Marketing-only slugs that union multiple API categories. Not TIntegrationCategory values. */
export const META_CATEGORIES = {
    erp: {
        name: 'ERP',
        data_type: 'ERP',
        seo_description:
            "One Unified API to read and write ERP data across HR, accounting, commerce, shipping, and payments. Launch native integrations 100x faster. You won't have to manage maintenance, manually sync data, or handle authorization.",
        llms_description: 'Enterprise resource planning workflows across HR, accounting, commerce, shipping, and payment APIs.',
        categories: ['hris', 'accounting', 'commerce', 'shipping', 'payment'] as TIntegrationCategory[],
    },
    pos: {
        name: 'POS',
        data_type: 'POS',
        seo_description:
            "One Unified API to read and write POS data across HR, accounting, commerce, and payments — including staff, attendance, and sales orders. Launch native integrations 100x faster. You won't have to manage maintenance, manually sync data, or handle authorization.",
        llms_description: 'Point-of-sale workflows across HR, accounting, commerce, and payment APIs, including staff, attendance, and sales orders.',
        categories: ['accounting', 'commerce', 'payment'] as TIntegrationCategory[],
    },
} as const;

export type TMetaCategorySlug = keyof typeof META_CATEGORIES;
